
const CartTypes =  {
    ADD_ITEM : 'ADD_ITEM',
    CLEAR_ITEM: 'CLEAR_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM'
}

export default CartTypes;
